import React from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import App from "./App";
import reportWebVitals from "./reportWebVitals";

import "bootstrap/dist/css/bootstrap.min.css";

import "./fonts/Inter/Inter-VariableFont_slnt,wght.ttf";
import "./fonts/Montserrat/Montserrat-VariableFont_wght.ttf";
import "./fonts/Montserrat/Montserrat-Italic-VariableFont_wght.ttf";

import { BrowserRouter } from "react-router-dom";

import { setupStore } from "./store";
import { Provider } from "react-redux";

ReactDOM.createRoot(document.getElementById("root")!).render(
  <React.StrictMode>
    <BrowserRouter>
      <Provider store={setupStore()}>
        <App />
      </Provider>
    </BrowserRouter>
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
